module.exports = __webpack_public_path__ + "img/10.95f8b675.jpg";